module.exports = __webpack_public_path__ + "img/J@2x.e4911ba8.jpg";